const initState = () => {
  return {
    productSelected: {},
    billSelected: {}
  };
};

const bridge = {
  state: {
    productSelected: initState().productSelected,
    billSelected: initState().billSelected
  },

  getters: {
    productSelected: state => state.productSelected,
    billSelected: state => state.billSelected
  },

  mutations: {
    SAVE_PRODUCT_SELECTED(state, payload) {
      state.productSelected = payload;
    },
    SAVE_BILL_TO_PRINT(state, payload) {
      state.billSelected = payload;
    }
  },

  actions: {
    SAVE_PRODUCT_SELECTED({ commit, dispatch }, payload) {
      commit("SAVE_PRODUCT_SELECTED", payload);
    },
    SAVE_BILL_TO_PRINT({ commit, dispatch }, payload) {
      commit("SAVE_BILL_TO_PRINT", payload);
    }
  }
};

export default bridge;
